/**
 * What somebody had typed in a chat and not sent, kept per conversation for
 * the life of the page: the chat's component comes and goes (switching the
 * panel's section unmounts it; on a phone closing the Chat sheet does too), and
 * a half-written message should not go with it.
 */
const drafts = new Map();

export const draftFor = (groupId) => (groupId == null ? '' : drafts.get(String(groupId)) ?? '');

export const keepDraft = (groupId, text) => {
  if (groupId == null) return;
  if (text) drafts.set(String(groupId), text);
  else drafts.delete(String(groupId));
};

// Tests reset between cases.
export const resetDraftsForTest = () => drafts.clear();
